<template>
    <div class="note-trash">
        <div class="note-trash-header">
            <span class="note-trash-title">{{ $t('pages.module.NOTE.trash.title') }}</span>
        </div>

        <div class="note-trash-items" v-if="notes.length > 0">
            <div v-for="note in notes" :key="note.id"
                 class="note-trash-item"
                 :class="{active: selectedNoteId === note.id, 'trash-item--deleting': deletingId === note.id}"
                 :data-note-id="note.id"
                 @click="$emit('selectNote', note)">
                <div class="note-trash-item-info">
                    <div class="note-trash-item-title">{{ note.title || '-' }}</div>
                    <div class="note-trash-item-date">{{ formatDate(note.deleted_at || note.updated_at) }}</div>
                </div>
                <div class="note-trash-item-actions" @click.stop>
                    <button class="trash-restore-btn" @click="$emit('restore', {id: note.id, restoreCategory: true})" :title="$t('pages.module.NOTE.trash.restore')">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                    </button>
                    <button class="trash-delete-btn" :title="$t('pages.module.NOTE.trash.permanentDelete')" @click="requestPermanentDelete(note.id)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                    </button>
                </div>
            </div>

            <div v-if="deletingId" class="trash-truck-container" :style="{top: truckTop + 'px'}">
                <div class="trash-truck">
                    <div class="trash-truck-cover trash-truck-cover--left"></div>
                    <div class="trash-truck-cover trash-truck-cover--right"></div>
                    <svg class="trash-truck-svg" width="70" height="44" viewBox="0 0 80 50" fill="none">
                        <path d="M5 8 L45 8 L45 36 L5 36 L5 8 Z" rx="3" fill="#6b7280" stroke="#4b5563" stroke-width="1.5"/>
                        <rect x="8" y="11" width="34" height="22" rx="2" fill="#4b5563"/>
                        <line x1="19" y1="11" x2="19" y2="33" stroke="#374151" stroke-width="1"/>
                        <line x1="30" y1="11" x2="30" y2="33" stroke="#374151" stroke-width="1"/>
                        <rect x="0" y="10" width="6" height="24" rx="1" fill="#4b5563" stroke="#374151" stroke-width="0.5"/>
                        <rect x="45" y="14" width="24" height="22" rx="3" fill="#3b82f6" stroke="#2563eb" stroke-width="1.5"/>
                        <rect x="52" y="17" width="14" height="10" rx="2" fill="#93c5fd" opacity="0.8"/>
                        <line x1="54" y1="18" x2="54" y2="25" stroke="#bfdbfe" stroke-width="1" opacity="0.6"/>
                        <line x1="52" y1="28" x2="52" y2="36" stroke="#2563eb" stroke-width="1"/>
                        <rect x="65" y="30" width="6" height="6" rx="1" fill="#9ca3af"/>
                        <circle cx="14" cy="40" r="5.5" fill="#1f2937" stroke="#111827" stroke-width="1"/>
                        <circle cx="14" cy="40" r="2" fill="#6b7280"/>
                        <circle cx="56" cy="40" r="5.5" fill="#1f2937" stroke="#111827" stroke-width="1"/>
                        <circle cx="56" cy="40" r="2" fill="#6b7280"/>
                    </svg>
                    <div class="truck-exhaust">
                        <div class="smoke-puff smoke-puff-1"></div>
                        <div class="smoke-puff smoke-puff-2"></div>
                        <div class="smoke-puff smoke-puff-3"></div>
                        <div class="smoke-puff smoke-puff-4"></div>
                        <div class="smoke-puff smoke-puff-5"></div>
                        <div class="smoke-puff smoke-puff-6"></div>
                        <div class="smoke-puff smoke-puff-7"></div>
                        <div class="smoke-puff smoke-puff-8"></div>
                        <div class="smoke-puff smoke-puff-9"></div>
                        <div class="smoke-puff smoke-puff-10"></div>
                        <div class="smoke-puff smoke-puff-11"></div>
                        <div class="smoke-puff smoke-puff-12"></div>
                        <div class="smoke-puff smoke-puff-13"></div>
                        <div class="smoke-puff smoke-puff-14"></div>
                        <div class="smoke-puff smoke-puff-15"></div>
                        <div class="smoke-puff smoke-puff-16"></div>
                        <div class="smoke-puff smoke-puff-17"></div>
                        <div class="smoke-puff smoke-puff-18"></div>
                        <div class="smoke-puff smoke-puff-19"></div>
                        <div class="smoke-puff smoke-puff-20"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="note-trash-empty" v-else>
            <div class="note-trash-empty-icon">🗑️</div>
            <div class="note-trash-empty-title">{{ $t('pages.module.NOTE.trash.empty') }}</div>
            <div class="note-trash-empty-desc">{{ $t('pages.module.NOTE.trash.emptyDescription') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoteTrash',
    props: {
        notes: {type: Array, default: () => []},
        selectedNoteId: {default: null},
    },
    emits: ['restore', 'permanentDelete', 'selectNote'],
    data() {
        return {
            deletingId: null,
            truckTop: 0,
        }
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return ''
            return this.$moment(dateStr).format('D.MM.YYYY HH:mm')
        },
        requestPermanentDelete(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('pages.module.NOTE.trash.permanentDeleteTitle'),
                message: this.$t('pages.module.NOTE.trash.permanentDeleteMessage'),
                confirmText: this.$t('common.delete'),
                cancelText: this.$t('common.cancel'),
                confirmType: 'danger',
                onConfirm: () => this.onPermanentDelete(id),
            })
        },
        onPermanentDelete(id) {
            const container = this.$el.querySelector('.note-trash-items')
            const item = this.$el.querySelector(`[data-note-id="${id}"]`)
            if (container && item) {
                const cRect = container.getBoundingClientRect()
                const iRect = item.getBoundingClientRect()
                this.truckTop = iRect.top - cRect.top + container.scrollTop + iRect.height / 2 - 22
            }
            this.deletingId = id
            setTimeout(() => {
                if (item) item.style.visibility = 'hidden'
            }, 1560)
            setTimeout(() => {
                this.deletingId = null
                this.$emit('permanentDelete', {id})
            }, 2200)
        },
    }
}
</script>

<style scoped>
.note-trash {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--note-list-bg, #ffffff);
}

.note-trash-header {
    padding: 12px;
    border-bottom: 1px solid var(--panel-border, #e5e5ea);
    flex-shrink: 0;
}

.note-trash-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--panel-text-primary, #1c1c1e);
}

.note-trash-items {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px 0;
    position: relative;
}

.note-trash-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-radius: 6px;
    margin: 1px 6px;
    transition: background 0.15s, transform 0.5s ease-in, opacity 0.5s ease-in;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    z-index: 1;
}

.note-trash-item:hover {
    background: var(--note-item-hover, #f5f5f5);
}

.note-trash-item.active {
    background: var(--panel-selected-bg);
}

.trash-item--deleting {
    z-index: 0;
    animation: cardHide 2.2s linear forwards;
}

@keyframes cardHide {
    0% { opacity: 1; }
    70% { opacity: 1; }
    71% { opacity: 0; }
    100% { opacity: 0; }
}

.trash-truck-container {
    position: absolute;
    left: 0;
    right: 0;
    height: 44px;
    pointer-events: none;
    z-index: 5;
}

.trash-truck {
    position: relative;
    animation: truckDrive 2.2s forwards;
    animation-timing-function: linear;
}

.trash-truck-svg {
    position: relative;
    z-index: 2;
}

.trash-truck-cover {
    position: absolute;
    top: -10px;
    width: 600px;
    height: 64px;
    background: var(--note-list-bg, #ffffff);
    z-index: 1;
}

.trash-truck-cover--right {
    left: 0;
}

.trash-truck-cover--left {
    right: 0;
    opacity: 0;
    animation: showLeftCover 2.2s linear forwards;
}

@keyframes showLeftCover {
    0% { opacity: 0; }
    71% { opacity: 0; }
    72% { opacity: 1; }
    100% { opacity: 1; }
}

@keyframes truckDrive {
    0% {
        transform: translateX(500px);
    }
    55% {
        transform: translateX(4px);
    }
    58% {
        transform: translateX(10px);
    }
    60% {
        transform: translateX(4px);
    }
    72% {
        transform: translateX(4px);
    }
    100% {
        transform: translateX(500px);
    }
}

.truck-exhaust {
    position: absolute;
    left: -10px;
    top: 8px;
    width: 30px;
    height: 30px;
    pointer-events: none;
    z-index: 3;
}

.smoke-puff {
    position: absolute;
    border-radius: 50%;
    background: #6b7280;
    opacity: 0;
    bottom: 0;
    left: 0;
}

:global(html.dark) .smoke-puff {
    background: #9ca3af;
}

.smoke-puff-1  { width: 16px; height: 16px; animation: smokePuff1 0.9s ease-out 1.54s forwards; }
.smoke-puff-2  { width: 22px; height: 22px; animation: smokePuff2 0.9s ease-out 1.57s forwards; }
.smoke-puff-3  { width: 13px; height: 13px; animation: smokePuff3 0.9s ease-out 1.60s forwards; }
.smoke-puff-4  { width: 24px; height: 24px; animation: smokePuff1 0.9s ease-out 1.63s forwards; }
.smoke-puff-5  { width: 15px; height: 15px; animation: smokePuff2 0.9s ease-out 1.66s forwards; }
.smoke-puff-6  { width: 20px; height: 20px; animation: smokePuff3 0.9s ease-out 1.69s forwards; }
.smoke-puff-7  { width: 14px; height: 14px; animation: smokePuff1 0.9s ease-out 1.72s forwards; }
.smoke-puff-8  { width: 26px; height: 26px; animation: smokePuff2 0.9s ease-out 1.75s forwards; }
.smoke-puff-9  { width: 18px; height: 18px; animation: smokePuff3 0.9s ease-out 1.78s forwards; }
.smoke-puff-10 { width: 22px; height: 22px; animation: smokePuff1 0.9s ease-out 1.80s forwards; }
.smoke-puff-11 { width: 13px; height: 13px; animation: smokePuff2 0.9s ease-out 1.82s forwards; }
.smoke-puff-12 { width: 24px; height: 24px; animation: smokePuff3 0.9s ease-out 1.84s forwards; }
.smoke-puff-13 { width: 16px; height: 16px; animation: smokePuff1 0.9s ease-out 1.86s forwards; }
.smoke-puff-14 { width: 20px; height: 20px; animation: smokePuff2 0.9s ease-out 1.88s forwards; }
.smoke-puff-15 { width: 25px; height: 25px; animation: smokePuff3 0.9s ease-out 1.90s forwards; }
.smoke-puff-16 { width: 14px; height: 14px; animation: smokePuff1 0.9s ease-out 1.92s forwards; }
.smoke-puff-17 { width: 22px; height: 22px; animation: smokePuff2 0.9s ease-out 1.94s forwards; }
.smoke-puff-18 { width: 18px; height: 18px; animation: smokePuff3 0.9s ease-out 1.96s forwards; }
.smoke-puff-19 { width: 26px; height: 26px; animation: smokePuff1 0.9s ease-out 1.98s forwards; }
.smoke-puff-20 { width: 15px; height: 15px; animation: smokePuff2 0.9s ease-out 2.00s forwards; }

@keyframes smokePuff1 {
    0% {
        opacity: 0.85;
        transform: translate(0, 0) scale(0.4);
    }
    20% {
        opacity: 0.7;
        transform: translate(-160px, -8px) scale(1.4);
    }
    100% {
        opacity: 0;
        transform: translate(-350px, -18px) scale(2.4);
    }
}

@keyframes smokePuff2 {
    0% {
        opacity: 0.85;
        transform: translate(0, 0) scale(0.4);
    }
    20% {
        opacity: 0.7;
        transform: translate(-140px, -14px) scale(1.5);
    }
    100% {
        opacity: 0;
        transform: translate(-320px, -26px) scale(2.6);
    }
}

@keyframes smokePuff3 {
    0% {
        opacity: 0.85;
        transform: translate(0, 2px) scale(0.4);
    }
    20% {
        opacity: 0.7;
        transform: translate(-180px, -4px) scale(1.3);
    }
    100% {
        opacity: 0;
        transform: translate(-380px, -12px) scale(2.2);
    }
}

.note-trash-item-info {
    flex: 1;
    min-width: 0;
}

.note-trash-item-title {
    font-size: 13px;
    font-weight: 500;
    color: var(--panel-text-primary, #1c1c1e);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.note-trash-item-date {
    font-size: 11px;
    color: var(--panel-text-secondary, #8e8e93);
    margin-top: 2px;
}

.note-trash-item-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
}

.trash-restore-btn,
.trash-delete-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.15s;
}

.trash-restore-btn {
    background: rgba(var(--panel-accent-rgb), 0.08);
    color: var(--panel-accent-text);
}

.trash-restore-btn:hover {
    background: rgba(var(--panel-accent-rgb), 0.15);
}

.trash-delete-btn {
    background: rgba(255, 59, 48, 0.08);
    color: #FF3B30;
}

.trash-delete-btn:hover {
    background: rgba(255, 59, 48, 0.15);
}

.note-trash-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    text-align: center;
}

.note-trash-empty-icon {
    font-size: 40px;
    margin-bottom: 12px;
}

.note-trash-empty-title {
    font-size: 14px;
    font-weight: 500;
    color: var(--panel-text-primary, #1c1c1e);
    margin-bottom: 4px;
}

.note-trash-empty-desc {
    font-size: 12px;
    color: var(--panel-text-secondary, #8e8e93);
}

.note-trash-items::-webkit-scrollbar {
    width: 4px;
}
.note-trash-items::-webkit-scrollbar-track {
    background: transparent;
}
.note-trash-items::-webkit-scrollbar-thumb {
    background: var(--panel-border, #e5e5ea);
    border-radius: 4px;
}
</style>
